import { getServiceVal } from "@/utils/cookies";
import { useSelector, useDispatch } from "react-redux";
import { loginUrl } from "@/utils/base";
import { useEffect, useState } from "react";
import { goLogin as goToLogin } from "@/utils/common";


export const useGetLoginInfo = () => {
  const dispatch = useDispatch();
  const [authorization, setAuthorization] = useState<string | null>("");
  const portalAuthorization = useSelector((state: any) => state.portalAuthorization || getServiceVal("Authorization"));

  const userDataChange = useSelector((state: any) => state.userDataChange);
  useEffect(() => {
    const storageAuthorization = getServiceVal("Authorization") || "";
    setAuthorization(storageAuthorization);
    // document.addEventListener("click", handleClickOutside);
    storageAuthorization &&
      dispatch({
        type: "setUserDataChange",
        payload: userDataChange + 1,
      });
    // return () => {
    //   document.removeEventListener("click", handleClickOutside);
    // };
  }, []);
  const goLogin = () => {
    goToLogin();
  };

  return {
    authorization,
    portalAuthorization,
    goLogin,
  };
};
